import { useQuery } from '@apollo/client';

import useCompanyContext from 'common/hooks/useCompanyContext';

import { LastInvoiceFiscalIdDocument } from './graphql/lastInvoiceFiscalId.gql';

const useLastInvoiceFiscalId = () => {
  const { companyProfileId } = useCompanyContext();

  const { data, ...rest } = useQuery(LastInvoiceFiscalIdDocument, {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    skip: !companyProfileId,
    variables: { companyProfileId: companyProfileId ?? '' },
  });

  const lastInvoiceFiscalId = data?.viewer.company.lastInvoiceFiscalId;

  return { lastInvoiceFiscalId, ...rest };
};

export default useLastInvoiceFiscalId;
